'use client'

import { useActionState } from 'react'
import Link from 'next/link'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { forgotPassword } from '@/app/actions/auth'

export default function ForgotPasswordPage() {
  const [state, formAction, pending] = useActionState(forgotPassword, null)

  if (state?.success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle className="text-2xl text-center">メールを送信しました</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-gray-600 text-sm">
              登録済みのメールアドレスであれば、パスワード再設定のメールを送りました。
              <br />
              メールをご確認ください。
            </p>
            <p className="text-xs text-gray-400">
              届かない場合は迷惑メールフォルダをご確認ください。
            </p>
            <Link href="/login" className="block text-blue-600 hover:underline text-sm">
              ログインページへ戻る
            </Link>
          </CardContent>
        </Card>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl text-center">パスワードをお忘れの方</CardTitle>
          <CardDescription className="text-center">
            登録済みのメールアドレスを入力してください。パスワード再設定のリンクをお送りします。
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form action={formAction} className="space-y-4">
            {state?.error && (
              <div className="p-3 rounded bg-red-50 border border-red-200 text-red-700 text-sm">
                {state.error}
              </div>
            )}
            <div className="space-y-2">
              <Label htmlFor="email">メールアドレス</Label>
              <Input id="email" name="email" type="email" required placeholder="your@email.com" />
            </div>
            <Button type="submit" className="w-full" disabled={pending}>
              {pending ? '送信中...' : '再設定メールを送る'}
            </Button>
          </form>
          <p className="mt-4 text-center">
            <Link href="/login" className="text-sm text-gray-500 hover:underline">
              ログインページへ戻る
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
